import { render, staticRenderFns } from "./EventView_Main.vue?vue&type=template&id=be0498ee&"
import script from "./EventView_Main.vue?vue&type=script&lang=js&"
export * from "./EventView_Main.vue?vue&type=script&lang=js&"
import style0 from "./EventView_Main.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports